import { useEffect } from 'react';

import { Box } from 'components/Box';
import { NotFoundContent } from 'components/NotFoundContent/NotFoundContent';
import { Layout } from 'layouts/Layout/Layout';
import { gutterWidth, maxWidth } from 'theme/theme';
import { setDocumentTitle } from 'utils/meta/setDocumentTitle';

type Props = {
  searchText?: string;
  searchUrl?: string;
  noLayout?: boolean;
};

export function NotFoundPage({ searchText, searchUrl, noLayout }: Props) {
  useEffect(() => {
    /* TRANSLATORS: 404 page title */
    setDocumentTitle(getText('Page Not Found'));
  }, []);

  const body = (
    <Box
      mx="auto"
      maxWidth={[480, null, maxWidth[3]]}
      px={[gutterWidth / 2, null, null, gutterWidth]}
      py={[gutterWidth / 2, null, null, gutterWidth, '28px']}
    >
      <NotFoundContent searchText={searchText} searchUrl={searchUrl} />
    </Box>
  );

  if (noLayout) return body;

  return <Layout>{body}</Layout>;
}
